<script>
import Model from "@/services/models/person";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      local: this.getLocalValue()
    }
  },
  methods: {
    getLocalValue() {
      return !(this.value instanceof Model) ? new Model(this.value) : this.value;
    },

    click() {
      this.$emit('click', this.local);
    }
  },
  watch: {
    value() {
      this.local = this.getLocalValue();
    }
  }
};
</script>

<template>
  <a class="text-primary" role="button" :title="local.last_name + ' ' + local.first_name" @click="click">
    <span class="badge text-capitalize"
          :class="local.active === 1 ? 'badge-soft-primary bg-secondary' : 'badge-soft-danger'">
      {{ local }}
    </span>
  </a>
</template>
